import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { relativeDate, userFullName } from '../message-helpers';
import { MessageReply } from '@app/app/interfaces/message-reply.model';

@Component({
  selector: 'app-message-reply',
  templateUrl: './message-reply.component.html',
  styleUrl: './message-reply.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageReplyComponent {
  reply = input.required<MessageReply>();

  readonly userFullName = userFullName;
  readonly relativeDate = relativeDate;

  constructor() {}
}
